module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "root"
  }, [_c('span', [_vm._v(".")]), _vm._v(" "), _c('span', [_vm._v(".")]), _vm._v(" "), _c('span', [_vm._v(".")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63aa0c97!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/DotsLoading.vue
// module id = 1155
// module chunks = 2